<div class="registration-flow">
  <div class="registration-flow-option">
    <div class="registration-flow-text">
      <div class="title">
        {{ 'REGISTRATION-LINKS.REGISTRATION-FLOW.ALLOW-ADDING-EMPLOYEES' | translate }}
      </div>
      <div class="description">
        {{ 'REGISTRATION-LINKS.REGISTRATION-FLOW.ALLOW-ADDING-EMPLOYEES-DESCRIPTION' | translate }}
      </div>
    </div>

    <mat-slide-toggle
      class="req-toggle"
      [(ngModel)]="allowAddingEmployees"
      (ngModelChange)="onAllowAddingEmployeesChanged($event)"
    ></mat-slide-toggle>
  </div>

  @if (allowAddingEmployees) {
    <div class="registration-flow-sub-option">
      <div class="registration-flow-option">
        <div class="registration-flow-text">
          <div class="title">
            {{ 'REGISTRATION-LINKS.REGISTRATION-FLOW.CREATE-LOCATION-AUTOMATICALLY' | translate }}
          </div>
          <div class="description">
            {{ 'REGISTRATION-LINKS.REGISTRATION-FLOW.CREATE-LOCATION-AUTOMATICALLY-DESCRIPTION' | translate }}
          </div>
        </div>

        <mat-slide-toggle
          class="req-toggle"
          [(ngModel)]="createLocationAutomatically"
          [disabled]="!allowAddingEmployees"
          (ngModelChange)="onCreateLocationAutomaticallyChanged($event)"
        ></mat-slide-toggle>
      </div>

      @if (createLocationAutomatically) {
        <div class="parent-location">
          <div class="parent-location-selector">
            <dx-drop-down-box
              #locationDropDown
              [(value)]="parentLocationId"
              [inputAttr]="{ 'aria-label': 'Owner' }"
              valueExpr="id"
              displayExpr="name"
              [label]="('REGISTRATION-LINKS.REGISTRATION-FLOW.CREATE-NEW-LOCATION-UNDER' | translate) + ' *'"
              [dataSource]="locations"
              labelMode="floating"
              stylingMode="outlined"
              [showClearButton]="true"
              (onValueChanged)="locationDropDown.instance.close()"
            >
              <dx-validator validationGroup="customFields">
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.LOCATION-REQUIRED' | translate"
                ></dxi-validation-rule>
              </dx-validator>
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  [searchEnabled]="true"
                  [dataSource]="locations"
                  keyExpr="id"
                  dataStructure="plain"
                  [selectNodesRecursive]="false"
                  displayExpr="name"
                  (onItemClick)="onParentLocationChanged($event)"
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </div>
          <div class="parent-location-result" *ngIf="parentLocationId">
            <div class="result">
              {{ 'COMMON.RESULT' | translate }}
            </div>
            <div>
              {{ parentLocation?.name }}
              >
              <span class="company-name">
                {{ 'REGISTRATION-LINKS.REGISTRATION-FLOW.COMPANY-NAME-FROM-REGISTRATION' | translate }}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>